import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const hazardBaselineRoutes: Routes = [
  {
    title: 'pagesTitles.hazardBaselineLevels',
    path: APP_ROUTES.HAZARD_BASELINE_LEVELS,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardBaselineLevelsRead)],
    loadComponent: () =>
      import('./pages/hazard-baseline-levels').then((m) => m.HazardBaselineLevels),
  },
  {
    title: 'pagesTitles.hazardBaseline',
    path: APP_ROUTES.HAZARD_BASELINE,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardBaselineInputsRead)],
    loadComponent: () => import('./pages/hazard-baseline').then((m) => m.HazardBaseline),
  },
];
